<template>
  <el-tag v-if="tag" :type="tag.type" :hit="true" size="small">
    {{ tag.label }}
  </el-tag>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { ShowFlatDealStateLabels, FlatDealStates } from '@/api/types'

export default defineComponent({
  name: 'FlatDealState',
  props: {
    state: {
      type: String,
      default: ''
    },
    reason: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const tag = computed(() => {
      const state = props.state as FlatDealStates

      return ShowFlatDealStateLabels[state]
    })

    return { tag }
  }
})
</script>
<style lang="scss" scoped>
.el-tag {
  border: none !important;
}
.el-button--mini {
  padding: 2px 10px;
}
</style>
